import React from 'react';
import Divider from "@material-ui/core/Divider";
import {
	Card,
	Message,
	Input,
	Rule,
	Form,
	Select,
	Grid,
	Switch,
	Button,
	Modal,
} from "shineout";
import 'shineout/dist/theme.shineout.css'
import { withCookies } from "react-cookie";
import { create, update, get } from "../../network/ContentRules";
import { get as getAllApps } from "../../network/App";
import { get as getAllReleases } from "../../network/Release";
//import { getversion as getAllVersioncode } from "../../network/Release";
import { getversion as getAllVersioncode } from "../../network/Release";

const rules = Rule();
//style init
const styles = (theme) => ({
	theme: theme,
	root: {
		display: "wrap",
	},
	container: {
		display: "block",
		flexWrap: "wrap",
	},
	fab: {
		margin: theme.spacing(1),
	},
	box: {
		component: "div",
		display: "inline",
		flexWrap: "wrap",
	},
	card: {
		padding: theme.spacing(1),
		margin: theme.spacing(2),
	},
	textField: {
		margin: 8,
		padding: theme.spacing(1),
		width: 200,
	},
	media: {
		paddingTop: "56.25%",
	},

});
//Content rule details component

function error() {
	Modal.info({
		//title: 'This is a error message',
		fullScreen: true,
		resizable: true,
		style: {
			width: '70%',

		},
		content: <table class="tablecss">
			<thead>
				<tr>
					<th style={{ background: 'lightblue', color: 'black', textAlign: 'center', width: '5rem', height: '3rem' }}>KEY-MD5</th>
					<th style={{ background: 'lightblue', color: 'black', textAlign: 'center', width: '5rem', height: '3rem' }}>BOARDS</th>
					<th style={{ background: 'lightblue', color: 'black', textAlign: 'center', width: '5rem', height: '3rem' }}> SIGNATURES  </th>
				</tr>
			</thead>
			<tfoot>
				<tr>
					<td colspan="3"><b>This is information to get KEYMD5 details.</b></td>
				</tr>
			</tfoot>
			<tbody>
				<tr>
					<td style={{ padding: '0.25rem', textAlign: 'left', border: '1px solid #ccc', fontSize: '0.98rem' }}>FD889462A56360ED250705AF8603A602</td>
					<td style={{ padding: '0.25rem', textAlign: 'left', border: '1px solid #ccc', fontSize: '0.92rem' }}>
						BD_TP_MS358_PB801 ,
						BD_TP_MS358_PB802 ,
						BD_TP_MS358_PB803 ,
						BD_TP_MS358_PC821 ,
						TP.SK518D.PB802 ,
						TP.SK508S.PC821 ,
						TP.SK508.PB801 ,
						T.SK708D.81 ,
						TP.SK708D.PC821 ,
						TP.SK708D.PB801
					</td>
					<td style={{ padding: '0.25rem', textAlign: 'left', border: '1px solid #ccc', fontSize: '1.1rem' }}>Cloudwalker signatures</td>
				</tr>
				<tr>
					<td style={{ padding: '0.25rem', textAlign: 'left', border: '1px solid #ccc', fontSize: '0.98rem' }}>9C79D148A404F67E8D6CF23A45448B04</td>
					<td style={{ padding: '0.25rem', textAlign: 'left', border: '1px solid #ccc', fontSize: '0.92rem' }}>
						TP.SK708D.PC821 ,
						T.SK708D.81 ,
						TP.SK708D.PB801
					</td>
					<td style={{ padding: '0.25rem', textAlign: 'left', border: '1px solid #ccc', fontSize: '1.1rem' }}>CVTE signatures</td>
				</tr>
				<tr>
					<td style={{ padding: '0.25rem', textAlign: 'left', border: '1px solid #ccc', fontSize: '0.98rem' }}>7F799279DB10DC651D9884F329617FD8</td>
					<td style={{ padding: '0.25rem', textAlign: 'left', border: '1px solid #ccc', fontSize: '0.92rem' }}>
						TP.ATM30.PB801
					</td>
					<td style={{ padding: '0.25rem', textAlign: 'left', border: '1px solid #ccc', fontSize: '1.1rem' }}>CVTE signatures</td>
				</tr>
				<tr>
					<td style={{ padding: '0.25rem', textAlign: 'left', border: '1px solid #ccc', fontSize: '0.98rem' }}>8DDB342F2DA5408402D7568AF21E29F9</td>
					<td style={{ padding: '0.25rem', textAlign: 'left', border: '1px solid #ccc', fontSize: '0.92rem' }}>
						BD_TP_MS358_PB801 ,
						BD_TP_MS358_PB802 ,
						BD_TP_MS358_PB803 ,
						BD_TP_MS358_PC821 ,
						TP.MT5510I.PB801 ,
						TP.MT5510I.PB805
					</td>
					<td style={{ padding: '0.25rem', textAlign: 'left', border: '1px solid #ccc', fontSize: '1.1rem' }}>CVTE signatures</td>
				</tr>
				<tr>
					<td style={{ padding: '0.25rem', textAlign: 'left', border: '1px solid #ccc', fontSize: '0.98rem' }}>F14E1A306FE3B276BE29FD0DFD8170FB</td>
					<td style={{ padding: '0.25rem', textAlign: 'left', border: '1px solid #ccc', fontSize: '0.92rem' }}>
						TP.HV553.PC821B ,
						T.HV553.81B ,
						T.HV553.81B ,
						T.HV553.81 ,
						TP.SK508.PB801 ,
						TP.SK508.PB801 ,
						TP.SK508S.PC821 ,
					</td>
					<td style={{ padding: '0.25rem', textAlign: 'left', border: '1px solid #ccc', fontSize: '1.1rem' }}>CVTE signatures</td>
				</tr>

			</tbody>
		</table>,
	})
}

let barTimer;
// ponytail: fake progress — creeps to 90% while waiting, done() snaps to 100% when the API responds
function move() {
	var elem = document.getElementById("myBar");
	var width = 1;
	clearInterval(barTimer);
	barTimer = setInterval(() => {
		width += (90 - width) / 10;
		elem.style.width = width + '%';
	}, 50);
	return () => {
		clearInterval(barTimer);
		elem.style.width = '100%';
	};
}

class ContentRule extends React.Component {

	constructor(props) {
		super(props);
		console.log(this.props.history.location.state.data);
		//state init
		

		this.state = {
			token: this.props.cookies.cookies.token,
			username: this.props.cookies.cookies.username,
			ruleInfo: this.props.history.location.state.data,
			fields: [
				"emac",
				"mboard",
				"panel",
				"model",
				"version",
				"package",
				"brand",
				"cotaversion",
				"fotaversion",
				"accept_version",
				"ui_version",
			],
			field: [],
			apps: [],
			appList: [],
			distinct: {},
			releaseList: [],
			configuration: [],
			visible: false,
			configPaths: [],
			content: 1,
		};
	}

	componentWillMount() {
		
		
		//get All apps call
		getAllApps(this.state.token, {}, (data) => {
			console.log(data);
			this.setState({ appList: data }, () => {
				var apps = [];
				data.map((app) => {
					apps.push(app.package);
				});
				this.setState({ apps: apps });
			});
		});

		
	}	

	renderEmptyRule = (onAppend) => (
		<Button onClick={() => onAppend({})}>Add Rule</Button>
	);
	renderEmptyConfiguration = (onAppend) => (
		<Button onClick={() => onAppend({})}>Add Configuration</Button>
	);


	//render function
	render() {
		
		return (			
			<React.Fragment>
				<Card fullWidth>
					{/* Content rule dave button */}
					<Card.Header>
						Content rule defination
						<Card.Submit
							ariaLabel="SpeedDial openIcon"
							style={{
								position: "absolute",
								top: 10,
								right: 120,
							}}
						>
							Submit
						</Card.Submit>
						<Button type="error" onClick={error}>info</Button>
					</Card.Header>
				<div id="myBar" style={{
								height: 10,
								width: '1%',
								backgroundColor:"blue",
								textAlign: "center",
							}}></div>
					<Card.Body>
						<Form
							value={this.state.ruleInfo}
							scrollToError={30}
							//on submit content rule form
							onSubmit={(data) => {
								const done = move();
								console.log(data);

								if (!this.state.ruleInfo._id) {
									create(this.state.token, data,
										(result) => {
											done();
											console.log(result)
											if (result.success) {
												data._id = result._id
												//update state of result
												this.setState({ ruleInfo: data });
												Message.success("Content rule saved", 3, {
													position: "bottom-right",
												});
											} else {
												Message.error("Failed saving changes. Try again", 3, {
													position: "bottom-right",
												});
											}
										}
									);
								} else {
									//update content rule using _id
									data._id = this.state.ruleInfo._id
									update(this.state.token, data,
										(result) => {
											done();
											console.log(result)
											if (result) {
												Message.success("Content rule updated", 3, {
													position: "bottom-right",
												});
											} else {
												Message.error("Failed saving changes. Try again", 3, {
													position: "bottom-right",
												});
											}
										}
									);
								}

								//dont have _id create new rule else update existing
								
							}}
						>
							<Grid gutter={2}>
								<Grid width={0.8}>
									<Form.Item label="Description">
										<Input name="description" />
									</Form.Item>
								</Grid>
								<Grid width={0.2}>
									<Form.Item label="Enabled">
										<Switch name="isEnabled" />
									</Form.Item>
								</Grid>
								<h3>Rules</h3>
								{/* Dynamic rule creation component */}
								<Form.Item required style={{ marginTop: "16px" }}>
									<Form.FieldSet
										rules={[rules.min(1), rules.isExist]}
										name="rules"
										empty={this.renderEmptyRule}
									>
										{({ onAppend, onRemove }) => (
											<Grid
												gutter={1}
												style={{
													display: "flex",
													alignItems: "center",
													marginBottom: 12,
												}}
											>
												<Grid width={0.25}>
													<Form.Item required label="Field">
														<Select
															name="field"
															fullWidth
															data={this.state.fields}
															clearable
															onCreate
															keygen
															single
														/>
													</Form.Item>
												</Grid>

												<Grid width={0.25}>
													<Form.Item required label="Operator">
														<Select
															name="operator"
															fullWidth
															data={["IN", "NIN"]}
															clearable
															keygen
															single
														/>
													</Form.Item>
												</Grid>
												<Grid width={0.40}>
													<Form.Item required label="Values">
														<Select
															name="values"
															fullWidth
															onCreate
															clearable
															keygen
															onFilter={(text) => (d) =>
																d.toLowerCase().indexOf(text.toLowerCase()) >= 0}
															multiple
														/>
													</Form.Item>
												</Grid>
												<Grid width={0.1}>
													<a
														style={{ margin: "0 12px" }}
														onClick={() => onAppend({})}
													>
														<i className="material-icons">add</i>
													</a>
													<a onClick={onRemove}>
														<i className="material-icons">close</i>
													</a>
												</Grid>
												<Divider />
											</Grid>
										)}
									</Form.FieldSet>
								</Form.Item>
								<h3>Configuration</h3>
								{/* same for configuration to deliver, multiple configuration creation */}
								<Form.Item required style={{ marginTop: "16px" }}>
									<Form.FieldSet
										rules={[rules.min(1), rules.isExist]}
										name="configuration"
										empty={this.renderEmptyConfiguration}										
									>
										{({ value, onAppend, onRemove }) => (
											<Grid
												gutter={1}
												style={{
													display: "flex",
													alignItems: "center",
													marginBottom: 12,
												}}
											>
												<Grid width={0.45}>
													<Form.Item required label="Package name">
														<Select
															name="package"
															style={{ marginRight: 8 }}
															data={this.state.apps}
															onChange={(value) => {
																//Get all releases of spacified package name
																getAllReleases(
																	this.state.token,
																	{ package: value },
																	(data) => {
																		var releaseList = [];
																		//build release display string
																		data.map((release) =>
																			releaseList.push(release.whatsNew + " | " + release.versionCode + " |" + release._id)
																		);
																		this.setState({
																			releaseList: releaseList,
																		});
																		console.log("this.Package name",value);
																	}																	
																);
															}}
															clearable
															keygen
															single
															rules={[rules.min(1), rules.isExist]}
														/>
													</Form.Item>
												</Grid>
												<Grid width={0.45}>
													<Form.Item required label="Blocked">
														<Switch
															name="isBlocked"
															defaultValue={false}
														/>
													</Form.Item>
												</Grid>
												<Grid width={0.45}>
													<Form.Item required label="Is Latest">
														<Switch
															name="isLatest"
															defaultValue={false}
														/>
													</Form.Item>
												</Grid>	
							
												<Grid width={0.45}>
													<Form.Item label="Version code">
														<Select
															name="versionCode"
															style={{ marginRight: 8 }}
															data={this.state.releaseList}
															onChange={(value, index) => {
																//Get all releases of spacified package name
																var objretrive = value.split("|").pop();
    															console.log("*********$$$$$$$$$$$$$$$**************",objretrive)
																getAllVersioncode(
																	this.state.token,
																	{ objectID : value },
																	(data) => {
																		var configPaths = [];
																		var tempPaths = [];
																		//build release display string
																		data.map((release) =>
																			configPaths[objretrive] =release.path,
																		    //configPaths.push(tempPaths)
																		);
																		this.setState({
																			configPaths: configPaths,
																		});
																		console.log("this.Package name",JSON.stringify(configPaths));
																	}																	
																);
															}}													
															disabled={(value.isBlocked || value.isLatest)}
															clearable
															keygen
															single
														/>
													</Form.Item>
												</Grid>
												<Grid width={0.45}>
													<Form.Item required label="Action">
														<Select
															name="action"
															data={[
																"install",
																"uninstall",
																"upgrade",
																"downgrade",
															]}
															disabled={value.isBlocked}
															clearable
															keygen
															single
														/>
													</Form.Item>
												</Grid>
												<Grid width={0.45}>
													<Form.Item required label="Silent operation">
														<Switch name="isSilent"
															defaultValue={false}
															disabled={value.isBlocked}													
														/>
													</Form.Item>
												</Grid>
												{/*
												<Grid width={0.45}>
													<Form.Item required label="Base path">
														<label>{this.state.configPaths}</label>														
													</Form.Item>
												</Grid>

												<Grid width={0.45}>
													<Form.Item required label="Silent path">
													<label>{this.state.pathList}</label>
													</Form.Item>
												</Grid>
												*/}
												<Grid width={0.45}>
													<Form.Item required label="Hide app">
														<Switch name="isHidden"
															disabled={value.isBlocked}
															defaultValue={false} />
													</Form.Item>
												</Grid>
												<Grid width={0.45}>
													<Form.Item required label="Open Button">
														<Switch
															name="isOpenable"
															defaultValue={false}
															disabled={value.isBlocked || value.isHidden}
														/>
													</Form.Item>
												</Grid>
												<Grid width={0.45}>
													<Form.Item required label="Uninstall Button">
														<Switch
															name="isUninstallable"
															defaultValue={false}
															disabled={value.isBlocked || value.isHidden}
														/>
													</Form.Item>
												</Grid>
												<Grid width={0.45}>
													<Form.Item required label="Clear data">
														<Switch
															name="clearData"
															defaultValue={false}
															disabled={value.isBlocked}
														/>
													</Form.Item>
												</Grid>
												
												<Grid width={0.45}>
													<Form.Item required label="Reboot on complete">
														<Switch
															name="reboot"
															defaultValue={false}
															disabled={value.isBlocked}
														/>
													</Form.Item>
												</Grid>
												<Grid width={0.45}>
													<Form.Item required label="Uninstall First">
														<Switch
															name="uninstallFirst"
															defaultValue={false}
															disabled={value.isBlocked}
														/>
													</Form.Item>
												</Grid>
												<Grid width={0.1}>
													<a
														style={{ margin: "0 12px" }}
														onClick={() => onAppend({})}
													>
														<i className="material-icons">add</i>
													</a>
													<a onClick={onRemove}>
														<i className="material-icons">close</i>
													</a>
												</Grid>
												<Divider />
											</Grid>
										)}
									</Form.FieldSet>
								</Form.Item>
							</Grid>
						</Form>
					</Card.Body>
				</Card>
			</React.Fragment>
		);
	}
}

export default withCookies(ContentRule);
